import {
  DomainCmsListRepo,
  deleteDomainCmsRepo,
  postDomainCmsListRepo,
  getDomainCmsRepo,
  putDomainCmsRepo,
} from "../repositories/premium/domain";
import { createSlice } from "@reduxjs/toolkit";
const domainSlice = createSlice({
  name: "domainReducer",
  initialState: {
    domainListLoading: null,
    domainListData: null,
    domainListError: null,
    deleteDomainListLoading: null,
    deleteDomainListData: null,
    deleteDomainListError: null,
    domainIdDataLoading: null,
    domainIdData: null,
    domainIdDataError: null,
    putDomainIdDataLoading: null,
    putDomainIdData: null,
    putDomainIdDataError: null,
    postDomainDataLoading: null,
    postDomainData: null,
    postDomainDataError: null,
    message: null,
  },
  reducers: {
    getDomainListLoading(state, action) {
      return {
        ...state,
        domainListLoading: true,
      };
    },
    getDomainListSuccess(state, action) {
      return {
        ...state,
        domainListLoading: false,
        domainListData: action.payload,
      };
    },
    getDomainListFailure(state, action) {
      return {
        ...state,
        domainListLoading: false,
        domainListError: action.payload,
      };
    },
    deleteDomainListLoading(state, action) {
      return {
        ...state,
        deleteDomainListLoading: true,
        message: null,
      };
    },
    deleteDomainListSuccess(state, action) {
      return {
        ...state,
        deleteDomainListLoading: false,
        deleteDomainListData: action.payload,
        message: "Domain Details Deleted Successfully",
      };
    },
    deleteDomainListFailure(state, action) {
      return {
        ...state,
        deleteDomainListLoading: false,
        deleteDomainListError: action.payload,
        message: "Failure in Deleted Domain",
      };
    },
    cleardeleteDomainList(state, action) {
      return {
        ...state,
        deleteDomainListData: null,
        deleteDomainListError: null,
        message: null,
      };
    },
    getDomainIdDataLoading(state, action) {
      return {
        ...state,
        domainIdDataLoading: true,
      };
    },
    getDomainIdDataSuccess(state, action) {
      return {
        ...state,
        domainIdDataLoading: false,
        domainIdData: action.payload,
      };
    },
    getDomainIdDataFailure(state, action) {
      return {
        ...state,
        domainIdDataLoading: false,
        domainIdDataError: action.payload,
      };
    },
    putDomainIdDataLoading(state, action) {
      return {
        ...state,
        putDomainIdDataLoading: true,
        message:null
      };
    },
    putDomainIdDataSuccess(state, action) {
      return {
        ...state,
        putDomainIdDataLoading: false,
        putDomainIdData: action.payload,
        message: "Domain Data Edit Successfully",
      };
    },
    putDomainIdDataFailure(state, action) {
      return {
        ...state,
        putDomainIdDataLoading: false,
        putDomainIdDataError: action.payload,
        message: "Failure in Edit Domain",
      };
    },
    postDomainDataLoading(state, action) {
      return {
        ...state,
        postDomainDataLoading: true,
        message:null
      };
    },
    postDomainDataSuccess(state, action) {
      return {
        ...state,
        postDomainDataLoading: false,
        postDomainData: action.payload,
        message: "Domain Data Added Successfully",
      };
    },
    postDomainDataFailure(state, action) {
      return {
        ...state,
        postDomainDataLoading: false,
        postDomainDataError: action.payload,
        message: "Failure in Add Domain",
      };
    },
  },
});

export const {
  getDomainListLoading,
  getDomainListSuccess,
  getDomainListFailure,
  deleteDomainListLoading,
  deleteDomainListSuccess,
  deleteDomainListFailure,
  cleardeleteDomainList,
  getDomainIdDataLoading,
  getDomainIdDataSuccess,
  getDomainIdDataFailure,
  putDomainIdDataLoading,
  putDomainIdDataSuccess,
  putDomainIdDataFailure,
  postDomainDataLoading,
  postDomainDataSuccess,
  postDomainDataFailure,
} = domainSlice.actions;

export const getDomainList = (params) => {
  return async (dispatch) => {
    dispatch(getDomainListLoading());
    await DomainCmsListRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getDomainListSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getDomainListFailure(error.message));
        }
      });
  };
};
export const getDomainIdData = (params) => {
  return async (dispatch) => {
    dispatch(getDomainIdDataLoading());
    await getDomainCmsRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getDomainIdDataSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getDomainIdDataFailure(error.message));
        }
      });
  };
};
export const putDomainId = (params) => {
  return async (dispatch) => {
    dispatch(putDomainIdDataLoading());
    await putDomainCmsRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(putDomainIdDataSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(putDomainIdDataFailure(error.message));
        }
      });
  };
};
export const postDomain = (params) => {
  return async (dispatch) => {
    dispatch(postDomainDataLoading());
    await postDomainCmsListRepo(params)
      .then((response) => {
        if (response?.status == 201) {
          dispatch(postDomainDataSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postDomainDataFailure(error.message));
        }
      });
  };
};
export const deleteDomainList = (params) => {
  return async (dispatch) => {
    dispatch(deleteDomainListLoading());
    await deleteDomainCmsRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(deleteDomainListSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(deleteDomainListFailure(error.message));
        }
      });
  };
};

export default domainSlice.reducer;
